import {DetailSubMenus, DetailTab} from "../../../layout/content/detail/DetailSubMenus";
import {PanelWrapper} from "../../../layout/content/detail/PanelWrapper";
import {useCallback, useState} from "react";
import {CounselorMenus} from "../../../types/counselor";
import {useTranslation} from "react-i18next";
import {CounselorInfoDetail} from "./CounselorInfoDetail";

export function CounselorDetail() {
    /**
     * 상담사 개별창
     * 상세
     */

    const [selectedTab, ] = useState<CounselorMenus>(CounselorMenus.COUNSELOR_INFO);
    const {t} = useTranslation("counselorInfo");

    const onClickTabMenu = (type: CounselorMenus) => {
        alert('기능 개발중입니다.')
        // navigate(`/detail/member/user/${id}?${queryString.stringify({ type })}`);
    };

    const getContentDetail = useCallback((
        tab: CounselorMenus
    ) =>{
        switch (tab) {
            case CounselorMenus.COUNSELOR_INFO:
                return <CounselorInfoDetail />
        }
    },[])

    const tabMenus: DetailTab<CounselorMenus>[] = [
        {
            tabValue: CounselorMenus.COUNSELOR_INFO,
            tabName: t('menus.counselorInfo'),
        },
    ];

    return(
        <>
            <DetailSubMenus
                tabs={tabMenus}
                onClickTab={onClickTabMenu}
                selectedTab={selectedTab}
            />
            <PanelWrapper>{getContentDetail(selectedTab)}</PanelWrapper>
        </>
    )
}